// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__okbzT","container":"Header_container__1QTVL","backIcon":"Header_backIcon__2RO39"};